import script from "./LandingSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingSteps.vue?vue&type=script&setup=true&lang=js"

import "./LandingSteps.vue?vue&type=style&index=0&id=5cbb13f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbb13f1"]])

export default __exports__